var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 61,
    viewBox: "0 0 60 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.50009 15.277C2.49969 15.3016 2.49965 15.3263 2.49997 15.3509V45.3203C2.49997 49.451 5.86926 52.8203 9.99997 52.8203H50C54.1307 52.8203 57.5 49.451 57.5 45.3203V15.3512C57.5003 15.3264 57.5003 15.3015 57.4998 15.2766C57.4762 11.1659 54.1161 7.82031 50 7.82031H9.99997C5.88372 7.82031 2.52357 11.1661 2.50009 15.277ZM7.76641 14.2052C8.17986 13.3876 9.03007 12.8203 9.99997 12.8203H50C50.9699 12.8203 51.8201 13.3876 52.2335 14.2052L30 29.7687L7.76641 14.2052ZM52.5 20.122V45.3203C52.5 46.6896 51.3693 47.8203 50 47.8203H9.99997C8.63068 47.8203 7.49997 46.6896 7.49997 45.3203V20.122L28.5663 34.8684C29.4271 35.471 30.5728 35.471 31.4336 34.8684L52.5 20.122Z",
    fill: "#EB5B1E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.a7c649fab33285a83bfa88757419be56.svg";
export { ForwardRef as ReactComponent };